import { CSSProperties } from "react";
import { Colors } from "../../utils/colors";
import RectangleButton from "./RectangleButton";

type FatHeaderActionButtonProps = {
  title: string | JSX.Element;
  onPress: () => void;
  icon?: JSX.Element;
  leftIcon?: boolean;
  loading?: boolean;
  disabled?: boolean;
  containerStyles?: CSSProperties;
  hideOpacityChange?: boolean;
};

// This button is used on headers of pages and flows (has border around button)
const FatHeaderActionButton = (props: FatHeaderActionButtonProps) => {
  const {
    title,
    onPress,
    icon,
    loading,
    containerStyles,
    disabled,
    leftIcon,
    hideOpacityChange,
  } = props;

  const styles = {
    headerRightButton: {
      whiteSpace: "nowrap",
      border: `1.5px solid ${Colors.GRAY2}`,
      ...containerStyles,
    },
  };

  return (
    <RectangleButton
      buttonLabel={title}
      onPress={onPress}
      containerStyles={styles.headerRightButton}
      altPaddingHorz={20}
      altPaddingVert={14}
      altBorderRadius={100}
      width={loading ? 100 : undefined}
      altTextColor={containerStyles?.color || Colors.BLACK}
      altColor={containerStyles?.backgroundColor || Colors.WHITE1}
      iconRight={leftIcon ? undefined : icon}
      iconLeft={leftIcon ? icon : undefined}
      loading={loading}
      disabled={disabled}
      hideOpacityChange={hideOpacityChange}
    />
  );
};

export default FatHeaderActionButton;
